import { createUseStyles } from 'react-jss'
import { mediumGrey } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  sectionContainer: {
    padding: '12px 16px',
    margin: 0
  },
  headingContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 14
  },
  title: {
    fontSize: 17,
    fontWeight: 700
  },
  value: {
    fontWeight: 700,
    fontSize: 27,
    marginTop: 10
  },
  valueDescription: {
    fontSize: 17,
    fontWeight: 400,
    color: mediumGrey
  }
})

export default useStyles
